/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/claim-detail';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 380,
        padding: 0,
    },
    columnWidth: {
        type: 100,
        memberId: 100,
        pcn: 60,
        bin: 60,
        groupNumber: 80,
        effectiveDate: 120,
       
    },
    filterFlyoutWidths: {},
    valueColors: {},
    actionIcons: {},
};
